import React, { useEffect, useState } from "react";
import CustomButton from "../../components/form/CustomButton";
import FiltersPagination from "../../components/elements/FiltersPagination";
import DataTableElement from "../../components/elements/DataTableElement";
import { Columns } from "./Columns";
import AddUpConfigurationAlert from "./AddUpConfigurationAlert";
import { getStatuses, servicesOrderResource, configurationsAlertsResource } from "../../helpers/configRoutes/backend_helper";
import { useDispatch, useSelector } from "react-redux";
import { update_notification_alerts, reset_notification_alerts } from "../../store/notificationAlerts/action";

const ConfigurationAlerts = () => {
    const dispatch = useDispatch();
    const [filters, setFilters] = useState({ endDate: '', startDate: '', search: '', from: 0, to: 0, page: 1 });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [items, setItems] = useState([]);
    const [tableLoad, setTableLoad] = useState({ show: false });
    const [modal, setModal] = useState({ show: false });
    const [modalConfirm, setModalConfirm] = useState({ show: false, title: 'Delete Truck', loadig: false, textLoad: 'Processing' })
    const [statusesData, setStatusesData] = useState([])

    const openModalAdd = (action = {}) => {
        console.log(openModalAdd)
        dispatch(action.id ? update_notification_alerts(action) : reset_notification_alerts())
        setModal({
            ...modal,
            show: true,
            title: `Configurations ${action.name}`,
        });
    };


    useEffect(() => {
        const getCatalogs = async () => {
            const statusesResponse = await getStatuses({ params: { model: 'ServiceOrder' } })
            if (statusesResponse.status) {
                setStatusesData(statusesResponse.statuses)
            }
        };
        getCatalogs();
    }, []);

    const cols = Columns(openModalAdd, modalConfirm, setModalConfirm, setFilters, filters);

    useEffect(() => {
        const configurationsAlerts = async () => {
            setTableLoad({ show: true })
            try {
                const response = await configurationsAlertsResource("get", { param: filters });
                setItems(response.actions);
                setMeta(response.meta)
            } catch (error) {
                console.error("Error fetching service order:", error);
            }
            setTableLoad({ show: false })
        };
        configurationsAlerts();
    }, [filters]);

    const deleteServiceOrder = async () => {
        setModalConfirm({ ...modalConfirm, loading: true })
        const response = await servicesOrderResource('del', {}, modalConfirm.id);
        if (response.status) {
            setFilters({ ...filters })
        }
        setModalConfirm({ ...modalConfirm, loading: false, show: false, id: null })
    }

    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                <div className="max-w-auto mx-auto px-4 md:px-6 py-6">
                    {/* Header */}
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                        <div>
                            <h1 className="text-2xl font-semibold text-cs-dark">
                                Configuration alerts
                            </h1>
                            <p className="text-sm text-cs-muted mt-1">
                                Define rules and thresholds for licenses, DOT and compliance alerts.
                            </p>
                        </div>

                        <div className="flex items-center gap-3">
                            <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                                Total rules:{" "}
                                <span className="font-semibold text-cs-dark">
                                    {meta?.total || items.length || 0}
                                </span>
                            </div>

                            <button
                                type="button"
                                onClick={() =>
                                    setModal((prev) => ({
                                        ...prev,
                                        show: true,
                                        id: null,
                                        title: "Add new alert rule",
                                    }))
                                }
                                className="
            inline-flex items-center gap-2
            px-4 py-2.5
            rounded-xl
            bg-cs-primary hover:bg-cs-primary-hover
            text-white text-sm font-medium
            shadow-md hover:shadow-lg
            transition-all
          "
                            >
                                <span className="material-symbols-outlined text-sm">add_alert</span>
                                Add alert
                            </button>
                        </div>
                    </div>

                    {/* Table + pagination */}
                    <div
                        className="
        bg-cs-bg border border-cs-border rounded-2xl
        shadow-sm px-2 py-2
      "
                    >
                        <FiltersPagination
                            showFilters={false}
                            filters={filters}
                            setFilters={setFilters}
                            meta={meta}
                            statusModel="Settlement"
                        >
                            <DataTableElement
                                columns={cols}
                                items={items}
                                tableLoad={tableLoad}
                            />
                        </FiltersPagination>
                    </div>

                    {/* Modal */}
                    {modal.show && (
                        <AddUpConfigurationAlert
                            modal={modal}
                            setModal={setModal}
                            filters={filters}
                            setFilters={setFilters}
                        />
                    )}
                </div>
            </div>

        </>
    )
}

export default ConfigurationAlerts;